module.exports = __webpack_public_path__ + "img/rushhourlogo.30757b52.jpg";